"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopoverAlignment = void 0;
var objectUtilities_1 = require("../../../util/objectUtilities");
function usePopoverAlignment(popoverPosition, popoverOffset) {
    var styleOverrides = (function () {
        if (popoverOffset) {
            switch (popoverPosition) {
                case 'left':
                    return { marginLeft: -popoverOffset };
                case 'right':
                    return { marginLeft: popoverOffset };
                case 'bottom':
                case 'bottom right':
                case 'bottom left':
                    return { marginTop: popoverOffset };
                case 'top':
                    return { marginTop: -popoverOffset };
                default:
                    return (0, objectUtilities_1.exhaustivenessCheck)(popoverPosition);
            }
        }
        return undefined;
    })();
    var verticalAnchorOrigin = (function () {
        switch (popoverPosition) {
            case 'left':
                return 'center';
            case 'right':
                return 'center';
            case 'bottom':
            case 'bottom left':
            case 'bottom right':
                return 'bottom';
            case 'top':
                return 'top';
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(popoverPosition);
        }
    })();
    var verticalTransformOrigin = (function () {
        switch (popoverPosition) {
            case 'left':
                return 'center';
            case 'right':
                return 'center';
            case 'bottom':
            case 'bottom left':
            case 'bottom right':
                return 'top';
            case 'top':
                return 'bottom';
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(popoverPosition);
        }
    })();
    var horizontalAnchorOrigin = (function () {
        switch (popoverPosition) {
            case 'left':
            case 'bottom left':
                return 'left';
            case 'right':
            case 'bottom right':
                return 'right';
            case 'bottom':
                return 'center';
            case 'top':
                return 'center';
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(popoverPosition);
        }
    })();
    var horizontalTransformOrigin = (function () {
        switch (popoverPosition) {
            case 'left':
            case 'bottom right':
                return 'right';
            case 'right':
            case 'bottom left':
                return 'left';
            case 'bottom':
                return 'center';
            case 'top':
                return 'center';
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(popoverPosition);
        }
    })();
    return {
        styleOverrides: styleOverrides,
        verticalAnchorOrigin: verticalAnchorOrigin,
        verticalTransformOrigin: verticalTransformOrigin,
        horizontalAnchorOrigin: horizontalAnchorOrigin,
        horizontalTransformOrigin: horizontalTransformOrigin,
    };
}
exports.usePopoverAlignment = usePopoverAlignment;
